import { render, staticRenderFns } from "./BaseSelcet.vue?vue&type=template&id=29721651&scoped=true&"
import script from "./BaseSelcet.vue?vue&type=script&lang=js&"
export * from "./BaseSelcet.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelcet.vue?vue&type=style&index=0&id=29721651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29721651",
  null
  
)

export default component.exports